export default __webpack_public_path__ + "static/media/314521.964c6ea7.jpg";